// extracted by mini-css-extract-plugin
export default {"faqHeading":"Faqs_faqHeading__pK5bP","faqContent":"Faqs_faqContent__ohCOe"};